const cacheObject = { };
export default (
  cache, i18n, def,
  filter = (v) => /^exchange-vote2-/i.test(v)
) => {
  if (cacheObject[cache]) return cacheObject[cache];
  // 过滤key
  const filterKeys = Object.keys(i18n).filter(filter);
  // 缓存数据
  cacheObject[cache] = filterKeys.reduce((result, next) => {
    const [key, prop] = next.split('-').slice(2);
    const values = i18n[next];
    if (!values) return result;
    // 深度为1
    if (!prop) return { ...result, [key]: values };
    // 深度为2
    const next$ = result[key] || {};
    // 目前只有tr需要转换成数组
    if (/^tr/.test(prop) && /^\D+\d+$/.test(prop)) {
      const [$prop, $idx] = /^(\D+)(\d+)$/.exec(prop).slice(1);
      const $arr = next$[`${$prop}List`] || [];
      $arr[$idx - 1] = values;
      return {
        ...result, [key]: { ...next$, [`${$prop}List`]: $arr },
      };
    }
    return { ...result, [key]: { ...next$, [prop]: values } };
  }, def || {});
  return cacheObject[cache];
};
